import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { Description, CreditCard, Computer } from "@material-ui/icons/";

const ButtonDefault = withStyles((theme) => ({
  root: {
    float: "right",
    background: "#699E42",
    color: "#fff",
    fontSize: 16,
    borderRadius: 1,
    marginLeft: 10,
    width: 180,
    height: 62,
    cursor: "pointer",
    boxShadow: "-2px 4px 5px 0px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      background: "#2b7b2f",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0px",
    },
  },
  //checked: {}
}))((props) => <Button color="default" {...props} />);

const ButtonDefaultBackgroundTransparent = withStyles((theme) => ({
  root: {
    float: "right",
    background: "transparent",
    color: "#000",
    fontSize: 16,
    border: "1px solid #cecece",
    borderRadius: 1,
    marginLeft: 10,
    width: 180,
    height: 62,
    cursor: "pointer",
    boxShadow: "-2px 4px 5px 0px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      background: "#2b7b2f",
      color: "#fff",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0px",
    },
  },
  //checked: {}
}))((props) => <Button color="default" {...props} />);

const ButtonMenuDebitFilter = withStyles((theme) => ({
  root: {
    background: "#1874B9",
    color: "#fff",
    fontSize: 16,
    borderRadius: 1,
    marginLeft: 10,
    width: 150,
    height: 40,
    boxShadow: "-2px 4px 5px 0px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      background: "#0066b2",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0px",
    },
  },
  //checked: {}
}))((props) => <Button color="default" {...props} />);

const ButtonMenuDebitClose = withStyles((theme) => ({
  root: {
    marginLeft: 10,
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0px",
    },
  },
  //checked: {}
}))((props) => <Button color="default" {...props} />);

const ButtonLargeGreen = withStyles((theme) => ({
  root: {
    float: "right",
    background: "#699E42",
    color: "#fff",
    fontSize: 16,
    borderRadius: 1,
    width: "100%",
    height: 62,
    cursor: "pointer",
    boxShadow: "-2px 4px 5px 0px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      background: "#2b7b2f",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0px",
    },
  },
}))((props) => <Button color="default" {...props} />);

export default class ButtonTypeName extends Component {
  //1 - GERAR DAM
  //2 - PAGAR ONLINE
  //3 - PAGAR
  //4 - CADASTRAR
  //5 - ALTERAR COTAS
  //6 - FILTRAR
  //7 - FECHAR
  //8 - LIMPAR FILTROS
  //9 - LIMPAR FILTROS
  //10 - LIMPAR FILTROS
  //13 - SALVAR
  //14 - EDITAR
  //15 - PAGAR COM CARTÃO DE CRÉDITO
  //16 - PESQUISA BOTÃO GRANDE
  handleGetNameButton = () => {
    let contentButton = "";
    switch (this.props.typeButton) {
      case 1:
        contentButton = "Emitir DAM";
        break;
      case 2:
        contentButton = "Pagar Online";
        break;
      case 3:
        contentButton = "Pagar";
        break;
      case 4:
        contentButton = "Cadastrar";
        break;
      case 5:
        contentButton =
          this.props.quotasSize === 1 ? "Alterar Cota" : "Alterar Cotas";
        break;
      case 6:
        contentButton = "Filtrar";
        break;
      case 7:
        contentButton = "Fechar";
        break;
      case 8:
        contentButton = "Limpar Filtros";
        break;
      case 9:
        contentButton = "Pesquisar";
        break;
      case 10:
        contentButton = "Reimprimir DAM";
        break;
      case 11:
        contentButton = "Exibir";
        break;
      case 12:
        contentButton = "Ocultar";
        break;
      case 13:
        contentButton = "Salvar";
        break;
      case 14:
        contentButton = "Editar";
        break;
      case 15:
        contentButton = "Pagar com cartão";
        break;
      case 16:
        contentButton = "Prosseguir";
        break;
      case 17:
        contentButton = "Pesquisar";
        break;
      case 18:
          contentButton = "Filtrar";
          break;
      default:
        contentButton = "ERRO";
        break;
    }
    return contentButton;
  };

  render() {
    return (
      <div onClick={this.props.action}>
        {(this.props.typeButton === 6 ||
          this.props.typeButton === 8 ||
          this.props.typeButton === 9) && (
          <ButtonMenuDebitFilter className={this.props.className}>
            {this.handleGetNameButton()}
          </ButtonMenuDebitFilter>
        )}
        {this.props.typeButton === 7 && (
          <ButtonMenuDebitClose className={this.props.className}>
            {this.handleGetNameButton()}
          </ButtonMenuDebitClose>
        )}
        {((this.props.typeButton < 6 || this.props.typeButton > 9) && this.props.typeButton < 17) &&
          this.props.backgroundTransparent !== true && (
            <ButtonDefault
              onClick={this.props.onClick}
              className={this.props.className}
            >
              {(this.props.icon && this.props.typeButton === 15 && (
                <CreditCard className={this.props.icon} style={{ fontSize: `${this.props.sizeIcon}px`}} />
              )) ||
                (this.props.typeButton === 2 && (
                  <Computer className={this.props.icon} style={{ fontSize: `${this.props.sizeIcon}px`}} />
                )) ||
                (this.props.typeButton === 1 && (
                  <Description className={this.props.icon} style={{ fontSize: `${this.props.sizeIcon}px`}} />
                ))}
              {this.handleGetNameButton()}
            </ButtonDefault>
          )}

        {(this.props.typeButton < 6 || this.props.typeButton > 9) &&
          this.props.backgroundTransparent === true && (
            <ButtonDefaultBackgroundTransparent
              onClick={this.props.onClick}
              className={this.props.className}
            >
              {this.handleGetNameButton()}
            </ButtonDefaultBackgroundTransparent>
          )}
        {(this.props.typeButton === 17 || this.props.typeButton === 18) && (
          <ButtonLargeGreen onClick={this.props.onClick}>
            {this.handleGetNameButton()}
          </ButtonLargeGreen>
        )}
      </div>
    );
  }
}
